import { render, staticRenderFns } from "./AddMany.vue?vue&type=template&id=632e0ded&"
import script from "./AddMany.vue?vue&type=script&lang=js&"
export * from "./AddMany.vue?vue&type=script&lang=js&"
import style0 from "./AddMany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddMany.vue"
export default component.exports